import { render, staticRenderFns } from "./pblProgramCoreLiteracy.vue?vue&type=template&id=35710cc0&scoped=true&"
import script from "./pblProgramCoreLiteracy.vue?vue&type=script&lang=js&"
export * from "./pblProgramCoreLiteracy.vue?vue&type=script&lang=js&"
import style0 from "./pblProgramCoreLiteracy.vue?vue&type=style&index=0&id=35710cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35710cc0",
  null
  
)

export default component.exports